import { getJSONCriteria } from 'modules/jsonRulesCriterias/scorecardCriteria';
import { AllRules } from 'modules/jsonRulesCriterias/scorecardCriteria/types';
import { ScoreCriteriaEntity, ScoreTierEntity } from './types';
import { ScorecardCreateVariables, ScorecardUpdateVariables, ScoreCriteriaJSON } from './api';

function customCriteriaTypeToUpperCase(customCriteriaType: string) {
  return customCriteriaType
    .trim()
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/\s+/g, '_')
    .toUpperCase();
}

export function mapCustomCriteria(
  customCriteria: ScoreCriteriaEntity['customCriteria'] = {},
  groupByKey: 'internalId' | 'name',
  keyMapper?: (key: string) => string
) {
  return Object.values(customCriteria).reduce<Record<string, any>>((acc, customCriteria) => {
    if (customCriteria) {
      const mappedKey = keyMapper ? keyMapper(customCriteria[groupByKey]) : customCriteria[groupByKey];

      acc[mappedKey] = customCriteria;
    }

    return acc;
  }, {});
}

function getScoreCriteriaJSON(data: ScoreCriteriaEntity[]) {
  return data.reduce<ScoreCriteriaJSON[]>((acc, scoreCriteria) => {
    const conditions = Object.entries(scoreCriteria.criteria ?? {}).map(([fact, values]) => ({
      fact: fact as AllRules,
      ...values,
    }));

    acc.push({
      criteria: scoreCriteria.criteria,
      ...getJSONCriteria(conditions),
      ...(scoreCriteria.customCriteria && {
        customCriteria: mapCustomCriteria(scoreCriteria.customCriteria, 'name', customCriteriaTypeToUpperCase),
      }),
    });

    return acc;
  }, []);
}

export function collectCreateAPIPayloadFromScorecard(
  criteriaBuilderValue: ScoreCriteriaEntity[],
  tiersBuilderValue: ScoreTierEntity[]
): ScorecardCreateVariables['input'] {
  return {
    validDateEnd: null,
    validDateStart: null,
    nameInternal: 'SCORECARD',
    financeProgramModificationSettings: { markup: false },
    prescreenCriteriaInput: {
      name: 'SCORECARD',
      notes: null,
      guidelines: null,
      lenderProfileIdsToLink: [],
      financeProgramIdsToLink: [],
      jsonCriteria: {
        scoreCriteria: getScoreCriteriaJSON(criteriaBuilderValue),
        scoreTiers: tiersBuilderValue,
      },
    },
  };
}

export function collectUpdateAPIPayloadFromScorecard(
  accountId: string,
  prescreenCriteriaId: string,
  criteriaBuilderValue: ScoreCriteriaEntity[],
  tiersBuilderValue: ScoreTierEntity[]
): ScorecardUpdateVariables['input'] {
  return {
    accountId,
    prescreenCriteriaId,
    jsonCriteria: {
      scoreCriteria: getScoreCriteriaJSON(criteriaBuilderValue),
      scoreTiers: tiersBuilderValue,
    },
  };
}
